import { useState } from 'react';
import { useSetRecoilState } from 'recoil';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { addDefaultBookmarkInTicketList } from '../../handler/ListTicketKnowledgeHandler';
import { triggerReLoadKnowledgeTicketDetailAtom } from '@/state/atom/ticketKnowledgeAtom';
import DataChangePleaseReloadModal from '../../../common/modal/DataChangePleaseReloadModal';
import { createKibanaEditContentOperation } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { triggerReLoadHelpdeskTicketDetailAtom } from '@/state/atom/ticketAtom';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

TagDefaultBookmark.propTypes = {
    className: PropTypes.any,
    isViewDelete: PropTypes.any,
    ticketKnowledge: PropTypes.any,
    setTriggerReloadKnowledgeListPanel: PropTypes.any,
    corporationDetail: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    userDetail: PropTypes.any,
    bookmarkTargetType: PropTypes.any,
};
function TagDefaultBookmark({
    className = '',
    isViewDelete,
    ticketKnowledge,
    setTriggerReloadKnowledgeListPanel,
    corporationDetail,
    projectInuseDetail,
    userDetail,
    bookmarkTargetType
}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const userId = userDetail.id
    const projectInuseId = projectInuseDetail.id;
    const corporationInuseId = corporationDetail.id;

    const [isLoadingCursor, setIsLoadingCursor] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState({
        isOpen: false,
        errorCode: ''
    });
    const setTriggerReLoadKnowledgeTicketDetail = useSetRecoilState(triggerReLoadKnowledgeTicketDetailAtom);
    const setTriggerReLoadHelpdeskTicketDetail = useSetRecoilState(triggerReLoadHelpdeskTicketDetailAtom);
    
    return (
        <>
            <BookmarkWhiteIcon
                className={`bookmark-default-icon${isViewDelete ? ' disable' : ''}${isLoadingCursor ? ' waiting' : ''} ${className}`}
                isTaggedDefaultBookmark={ticketKnowledge.isBookmarkedDefaultBookmark}
                onClick={async() => {
                    if (isViewDelete) return;
                    setIsLoadingCursor(true)
                    document.body.style.cursor = 'wait';
                    try {
                        // create log kibana when add bookmark to ticket.
                        const dataLog = {
                            corporationDetail: corporationDetail,
                            projectDetail: projectInuseDetail,
                            userDetail: userDetail,
                            ticketDetail: ticketKnowledge,
                            formDetail: {},
                            publicRange: ''
                        };
                        const logKibanaData = createKibanaEditContentOperation(dataLog);
                        logKibanaData.actionDetail = 'edit(addTag)'

                        const addResponse = await addDefaultBookmarkInTicketList(
                            ticketKnowledge.id,
                            userId,
                            projectInuseId,
                            corporationInuseId,
                            ticketKnowledge.isBookmarkedDefaultBookmark,
                            logKibanaData
                        )
                        if (!addResponse || !addResponse.status) {
                            setIsOpenModalReloadPage({
                                isOpen: true,
                                errorCode: addResponse.errorCode
                            });
                            return;
                        }
                        await Utils.delay(1000)
                        setTriggerReloadKnowledgeListPanel({
                            panelType:
                                bookmarkTargetType === Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE
                                    ? Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST
                                    : Constant.PANEL_TYPE.HELPDESK_TICKET_LIST
                        });
                        if (bookmarkTargetType === Constant.BOOKMARK_TARGET_TYPE.KNOWLEDGE) {
                            setTriggerReLoadKnowledgeTicketDetail(ticketKnowledge.id);
                        } else {
                            setTriggerReLoadHelpdeskTicketDetail(ticketKnowledge.id);
                        }

                    } catch (error) {
                        console.log('addDefaultBookmarkInTicketList error >>>', error)
                    } finally {
                        setIsLoadingCursor(false);
                        document.body.style.cursor = 'default';
                    }
                }}
            />
            
            {/* Reload Confirm Dialog */}
            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage.isOpen}
                setClose={() => setIsOpenModalReloadPage({isOpen: false, errorCode: ''})}
                content={trI18n(isOpenModalReloadPage.errorCode)}
            />
        </>
     );
}

export default TagDefaultBookmark;

const BookmarkWhiteIcon = ({ className, onClick, isTaggedDefaultBookmark = false }) => {
    return (
        <div
            className={className}
            onClick={onClick}
        >
            {
                (isTaggedDefaultBookmark) ? (
                    <svg style={{margin: '-2px -4px'}} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.50009 2.00019L4.00057 2.00001C4.00057 2.00001 4.00009 3.83715 4.00009 4.50019V20.9995C4.00015 21.1746 4.04619 21.3467 4.13361 21.4984C4.22103 21.6501 4.34677 21.7763 4.49824 21.8641C4.6497 21.952 4.8216 21.9986 4.99671 21.9992C5.17183 21.9998 5.34406 21.9544 5.49612 21.8675L10.7561 18.8625C10.9827 18.7331 11.2391 18.665 11.5001 18.665C11.7611 18.665 12.0175 18.7331 12.2441 18.8625L18.5041 21.8685C18.6563 21.9555 18.8287 22.0009 19.004 22.0002C19.1793 21.9995 19.3513 21.9528 19.5028 21.8646C19.6543 21.7765 19.78 21.6501 19.8673 21.4981C19.9545 21.3463 20.0002 21.1735 20.0001 20.9985V4.50019L20 2L17.5001 2.00019H6.50009Z" fill="#FFC000"/>
                        <path d="M9.88649 13.4206C9.73977 13.4977 9.5683 13.3731 9.59631 13.2098L9.99976 10.8567L8.29017 9.18951C8.17152 9.0738 8.23701 8.87226 8.40102 8.8484L10.7644 8.50461L11.8209 6.36364C11.8942 6.215 12.1062 6.21497 12.1796 6.36359L13.2368 8.50461L15.5994 8.84839C15.7634 8.87225 15.8288 9.07379 15.7102 9.18949L14.0006 10.8567L14.4033 13.2098C14.4313 13.3732 14.2598 13.4977 14.1131 13.4206L12.0002 12.3094L9.88649 13.4206Z" fill="#5F6368"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M6.50009 2.00019C5.83705 2.00019 4.00057 2.00001 4.00057 2.00001C4.00057 2.00001 4.00009 3.83715 4.00009 4.50019V20.9995C4.00015 21.1746 4.04619 21.3467 4.13361 21.4984C4.22103 21.6501 4.34677 21.7763 4.49824 21.8641C4.6497 21.952 4.8216 21.9986 4.99671 21.9992C5.17183 21.9998 5.34406 21.9544 5.49612 21.8675L10.7561 18.8625C10.9827 18.7331 11.2391 18.665 11.5001 18.665C11.7611 18.665 12.0175 18.7331 12.2441 18.8625L18.5041 21.8685C18.6563 21.9555 18.8287 22.0009 19.004 22.0002C19.1793 21.9995 19.3513 21.9528 19.5028 21.8646C19.6543 21.7765 19.78 21.6501 19.8673 21.4981C19.9545 21.3463 20.0002 21.1735 20.0001 20.9985V4.50019L20 2L17.5001 2.00019H6.50009ZM5 3C5 3 6.10227 3.00019 6.50009 3.00019H17.5001L19 3L19.0001 4.50019V21.0002L12.7401 17.9942C12.3624 17.7785 11.935 17.665 11.5001 17.665C11.0652 17.665 10.6377 17.7785 10.2601 17.9942L5.00009 20.9992V4.50019C5.00009 4.50019 5 3.5 5 3Z" fill="#5F6368"/>
                    </svg>
                ) : (
                    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.88649 11.4206C5.73977 11.4977 5.5683 11.3731 5.59631 11.2098L5.99976 8.85666L4.29017 7.18951C4.17152 7.0738 4.23701 6.87226 4.40102 6.8484L6.76443 6.50461L7.82089 4.36364C7.89423 4.215 8.10618 4.21497 8.17957 4.36359L9.23677 6.50461L11.5994 6.84839C11.7634 6.87225 11.8288 7.07379 11.7102 7.18949L10.0006 8.85666L10.4033 11.2098C10.4313 11.3732 10.2598 11.4977 10.1131 11.4206L8.00018 10.3094L5.88649 11.4206Z" fill="#5F6368"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M2.50009 0.000189676C1.83705 0.000189676 0.000570578 9.52052e-06 0.000570578 9.52052e-06C0.000570578 9.52052e-06 9.34723e-05 1.83715 9.34723e-05 2.50019V18.9995C0.000149739 19.1746 0.0461922 19.3467 0.133613 19.4984C0.221033 19.6501 0.346766 19.7763 0.498237 19.8641C0.649704 19.952 0.821596 19.9986 0.996715 19.9992C1.17183 19.9998 1.34406 19.9544 1.49612 19.8675L6.75609 16.8625C6.98269 16.7331 7.23914 16.665 7.50009 16.665C7.76105 16.665 8.0175 16.7331 8.24409 16.8625L14.5041 19.8685C14.6563 19.9555 14.8287 20.0009 15.004 20.0002C15.1793 19.9995 15.3513 19.9528 15.5028 19.8646C15.6543 19.7765 15.78 19.6501 15.8673 19.4981C15.9545 19.3463 16.0002 19.1735 16.0001 18.9985V2.50019L16 0L13.5001 0.000189676H2.50009ZM1 1C1 1 2.10227 1.00019 2.50009 1.00019H13.5001L15 1L15.0001 2.50019V19.0002L8.74009 15.9942C8.36243 15.7785 7.93503 15.665 7.50009 15.665C7.06516 15.665 6.63773 15.7785 6.26007 15.9942L1.00009 18.9992V2.50019C1.00009 2.50019 1 1.5 1 1Z" fill="#5F6368"/>
                    </svg>
                )
            }
        </div>
    )
};

BookmarkWhiteIcon.propTypes = {
    isTaggedDefaultBookmark: PropTypes.any,
    className: PropTypes.any,
    onClick: PropTypes.any,
};
